import { SettingsPageFrame } from '@eluve/blocks';
import { LayersPage } from '@eluve/frontend-feature-tenants';

export const OrganizationLayersPage: React.FC = () => (
  <SettingsPageFrame
    size="wide"
    title="Layers"
    parentTitle="Organization"
    backTo="../organization"
    description="Organize Eluve to best fit your practice"
  >
    <LayersPage />
  </SettingsPageFrame>
);
